module.exports = __webpack_public_path__ + "img/home_welcome_1.d13256d3.jpg";